// extracted by mini-css-extract-plugin
module.exports = {"template":"template_template__Es_BF"};